export const DIGITAL_ARCHIVE_PAGES_ORDER_FOR_PERMISSIONS = [
  'archive',
  'directory',
  'public_agent_module_permission',
  'group_module_permission',
]
